<template>
    <b-container fluid>
      <b-row>
        <b-col>

          <b-row class="justify-content-md-center mt-2 mb-3">
            <b-img-lazy height='300' width='300' rounded :src="$store.getters['device/maintenancesQRCode']" blank-color="#d9d9d9" />
          </b-row>

          <b-row class="justify-content-md-center mb-1"> 
            <b-button 
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              @click="()=> $store.dispatch('device/printMaintenancesQRCode')" 
              variant="primary" 
            >
              {{ $t('DEVICES_MAINTENANCES_PRINT_QRCODE_LABEL') }}
            </b-button>
          </b-row>

          <b-row class="justify-content-md-center">
            <b-button 
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              @click="()=> $router.push({name:'maintenances.device.list' , params:{id:$store.getters['device/device_id']}})" 
              variant="primary" 
            >
              {{ $t('DEVICES_MAINTENANCES_VISIT_LABEL') }}
            </b-button>
          </b-row>

        </b-col>

      </b-row>
    </b-container>
</template>

<script>

import {
  BButton, 
  BCol,
  BImgLazy,
  BRow, 
  BContainer, 
} from 'bootstrap-vue'

import { OrbitSpinner } from 'epic-spinners'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BRow,
    BCol,
    BContainer,
    BImgLazy,
    BButton,
    OrbitSpinner
  },
  directives:{
    Ripple
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}

.custom-timeline,
.d-flex.flex-sm-row.flex-column.flex-wrap.justify-content-between.mb-1.mb-sm-0 h6 {
  font-size: 19px;
  font-style: oblique;
  font-weight: bold;
}
</style>
